import React from 'react';
import { Wind } from 'lucide-react';
import { pmToAqi, getAqiCategory } from '../utils/airQualityUtils';

const LocationMap = ({
  loading,
  onLocationSelect,
  statistics,
  locationMap,
  selectedLocation,
  isToolbarOpen,
  visibleLocationIds
}) => {
  const visibleSet = visibleLocationIds ? new Set(visibleLocationIds.map(String)) : null;
  const processLocationData = (statistics) => {
    if (!statistics?.locations) return {};
    const locationStats = {};
    Object.entries(statistics.locations).forEach(([locationId, locationData]) => {
      const currentReadings = locationData.currentReadings || {};
      const timestamps = Object.values(currentReadings).map(r => new Date(r.timestamp).getTime());
      const latestTimestamp = timestamps.length > 0 ? Math.max(...timestamps) : null;
      
      if (locationData.hour?.adjustedAverage !== undefined) {
        const locationInfo = locationMap[locationId];
        locationStats[locationId] = {
          name: locationInfo?.fullName || locationData.name,
          fullName: locationInfo?.fullName || locationData.name,
          type: locationInfo?.type || locationData.type,
          adjustedAverage: locationData.hour.adjustedAverage,
          actualAverage: locationData.hour.rawAverage,
          sensorCount: Object.keys(currentReadings).length,
          latestTimestamp: latestTimestamp
        };
      }
    });
    return locationStats;
  };

  const locationStats = processLocationData(statistics);

  return (
    <div className="container mx-auto">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2">
        {Object.entries(locationStats)
          .filter(([id]) => !visibleSet || visibleSet.has(id.toString()))
          .sort(([, a], [, b]) => a.fullName.localeCompare(b.fullName))
          .map(([id, stats]) => {
            const aqi = pmToAqi(stats.adjustedAverage);
            const quality = getAqiCategory(aqi);
            const isSelected = selectedLocation?.id?.toString() === id.toString() && isToolbarOpen;

            return (
              <div
                key={id}
                className={`location-card p-2 rounded-lg border ${quality.bgColor} ${quality.borderColor} 
                  cursor-pointer hover:shadow-md transition-all duration-200
                  ${isSelected ? 'ring-2 ring-black shadow-lg scale-[1.02]' : 'hover:scale-[1.01]'}`}
                onClick={(e) => onLocationSelect(id, e)}
              >
                <h3 className="font-medium text-sm mb-1 line-clamp-1">
                  {stats.fullName}
                </h3>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1">
                    <Wind className="text-gray-500" size={14} />
                    <div>
                      <div className="text-base font-bold">{aqi}</div>
                      <div className="text-xs text-gray-500">{stats.adjustedAverage?.toFixed(1)} µg/m³</div>
                    </div>
                  </div>
                  <div>
                    <div className="text-xs font-medium">{quality.category}</div>
                    <div className="text-xs text-gray-500">{stats.sensorCount} sensors</div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default LocationMap;